// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2Gd6t","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2NKoH"};